<template>
  <el-card class="smart-link">
    <el-tabs @tab-click="changeTab" v-model="active">
      <el-tab-pane label="Recommended" name="recommended" class="recommended"></el-tab-pane>
      <el-tab-pane label="My Smartlink" name="my-smartlink" class="my-smartlink"></el-tab-pane>
    </el-tabs>
    <el-row type="flex" :gutter="20" class="mb-4">
      <el-col :span="6" v-if="active === 'my-smartlink'">
        <el-input
          v-model="params.search"
          placeholder="Search Link ID/Name"
          @keyup.enter.native="getList()"
        ></el-input>
      </el-col>

      <el-col :span="3" class="flex-end" v-if="active === 'my-smartlink'">
        <el-button type="primary" @click="getList()">Search</el-button>
      </el-col>

      <el-col :span="4" :push="active === 'my-smartlink' ? 11 : 20" class="flex-end justify-end">
        <el-button type="success" @click="createSml()">Create Smart Link</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table v-loading="sml_loading" empty-text="No Data" :fit="true" border :data="list">
        <el-table-column label="Icon" width="100">
          <template slot-scope="scope">
            <img :src="scope.row.icon_url" class="icon" alt="icon" />
          </template>
        </el-table-column>
        <el-table-column prop="gid" label="Link ID" min-width="120"></el-table-column>
        <el-table-column label="Name" min-width="380">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.name" placement="top">
              <span>{{ scope.row.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="Offer Type" min-width="140">
          <template slot-scope="scope">
            {{ getOfferType(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="Stream Type" min-width="200">
          <template slot-scope="scope">
            {{ showLabel(scope.row.restriction_type, offer_setting.restriction_type) }}
          </template>
        </el-table-column>
        <el-table-column label="Payout($)" min-width="240">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.payout_price === 0 ? 'Floating' : scope.row.payout_price"
              placement="top"
            >
              <span>{{ scope.row.payout_price === 0 ? 'Floating' : scope.row.payout_price }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="Application Status" min-width="200">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.approve_status == 0
                  ? 'Pending'
                  : scope.row.approve_status == 2
                  ? 'Unapproved'
                  : scope.row.approve_status == 1
                  ? 'Approved'
                  : 'Rejected'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Action" min-width="400" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="getTrend(scope.row)">
              Data
            </el-button>
            <el-button
              type="primary"
              @click="getLink(scope.row)"
              :disabled="scope.row.approve_status != 1"
            >
              Get Link
            </el-button>
            <el-button type="primary" @click="EditCreative(scope.row.gid)">
              Get Creative
            </el-button>
            <el-button
              type="success"
              @click="EditLink(scope.row.gid)"
              v-if="!default_sml.includes(scope.row.gid)"
            >
              Edit
            </el-button>
            <el-button
              type="primary"
              @click="applyOffer(scope.row)"
              v-if="scope.row.approve_status != 1"
              :disabled="scope.row.approve_status == 0"
            >
              Apply
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <pagination :page="page" @sizeChange="getList" @currentChange="getList"></pagination>
    <promotion-url
      v-if="show_promotion"
      :show.sync="show_promotion"
      @cancel="show_promotion = false"
      :sml="open_sml"
    ></promotion-url>
    <apply-offer
      v-if="show"
      :show.sync="show"
      :detailApply="detailApply"
      @cancel="show = false"
      @apply="applyCb"
    ></apply-offer>
    <trend
      v-if="show_trend"
      :show_trend.sync="show_trend"
      @cancel="show_trend = false"
      :sml="open_sml"
    ></trend>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import applyOffer from '../offers/applyOffer.vue'
import promotionUrl from './promotionUrl.vue'
import trend from './trend.vue'
import pagination from '../../components/pagination.vue'

export default {
  data() {
    return {
      active: 'recommended',
      page: {
        tot: 0,
        cur: 1,
        per: 50,
      },
      params: {
        search: '',
        sml_type: 1,
      },
      sml_loading: false,
      show_promotion: false,
      show_trend: false,
      list: [],
      offer_setting: {},
      open_sml: {
        oid: '',
      },
      detailApply: {},
      show: false,
    }
  },
  computed: {
    ...mapGetters(['settings', 'aid', 'channel_list', 'default_sml']),
  },
  created() {
    this.customer_type = this.settings.user ? this.settings.user.customer_type : -1

    // 获取常量参数
    if (this.$route.query.active === 'my') {
      this.active = 'my-smartlink'
    }
    this.$http
      .get('/api/common/get-offer-r/', {})
      .then(data => {
        this.offer_setting = data
        let add_all = {
          ad_type: 'All Type',
          incentive_type: 'All Type',
          payout_type: 'All Type',
          restriction_type: 'ALL',
          prelander: 'ALL',
        }
        for (let key in add_all) {
          let text = add_all[key]
          this.offer_setting[key].unshift({ id: 0, name: text })
        }
      })
      .catch(err => {
        this.notifyOpen('Error', this.executeError(err), 'error')
      })
    if (this.active === 'recommended') {
      this.params.gids = this.default_sml
    }
    if (this.channel_list.length === 0) {
      this.$store.dispatch('getChannelList').then(() => {
        this.getList()
      })
    } else {
      this.getList()
    }
  },
  methods: {
    changeTab(tab) {
      if (tab.name === 'recommended') {
        this.params.gids = this.default_sml
      } else {
        this.params.gids = []
      }
      this.getList()
    },
    getOfferType(row) {
      // CPL SML在smartlink结构中没有区分，只在offer结构中有区分，这里简单针对这两个默认sml做下区分@AAN-3812
      if (row.ad_type === 4) {
        return 'CPL'
      } else if (row.ad_type === 1) {
        return 'CPI'
      } else if (row.ad_type === 0) {
        return 'ALL'
      } else {
        return 'CPA'
      }
    },
    getTrend(row) {
      this.open_sml = row
      this.show_trend = true
    },
    getList() {
      this.sml_loading = true
      this.$http
        .get('/api/smartlink/list/', {
          params: {
            ...this.params,
            uid: this.active === 'recommended' ? undefined : this.aid,
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 10,
          },
        })
        .then(data => {
          this.sml_loading = false
          this.list = data.data
          this.changePageItem(this.page, data)
        })
        .catch(err => {
          this.sml_loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getLink(row) {
      if (this.settings.user.status === 0) {
        this.updateInfo(this.$route.path)
        return
      }
      this.open_sml = row
      this.show_promotion = true
    },
    EditLink(gid) {
      this.$router.push({ path: `/smartlink/edit/${gid}` })
    },
    EditCreative(gid) {
      this.$router.push({ path: `offers/sml-creative/${gid}` })
    },
    createSml() {
      this.$router.push({ path: '/smartlink/create/0/' })
    },
    applyOffer(offer) {
      if (this.settings.user.status === 0) {
        this.updateInfo(this.$route.path)
        return
      }
      this.detailApply = {
        offer: offer,
        channel_list: this.channel_list,
        aid: this.aid,
        link_type: 2,
      }

      this.show = true
    },
    applyCb() {
      this.detailApply.offer.approve_status = 0
      this.detailApply.offer.status = 0
      this.show = false
    },
  },
  components: {
    promotionUrl,
    pagination,
    applyOffer,
    trend,
  },
}
</script>

<style lang="scss">
.smart-link {
  .icon {
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
  .el-table td {
    padding: 2px 0;
  }
}
</style>
